import { networkColorKeyFor, networkIconFor } from '@alison/ui';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

interface NetworkBadgeProps {
  networkName: string;
  networkLogo: string;
}

export function NetworkBadge({ networkName, networkLogo }: NetworkBadgeProps): ReactNode {
  const theme = useTheme();
  const colorKey = networkColorKeyFor(networkLogo, networkName);
  const fallbackColor = colorKey ? theme.palette.network[colorKey] : theme.palette.text.secondary;
  const NetworkIcon = networkIconFor(networkLogo, networkName);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {NetworkIcon ? (
        <NetworkIcon sx={{ fontSize: 16 }} />
      ) : (
        <Box
          sx={{
            width: 16,
            height: 16,
            borderRadius: 1,
            bgcolor: fallbackColor,
            color: 'common.white',
            fontSize: 10,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {(networkLogo || networkName).charAt(0).toUpperCase()}
        </Box>
      )}
      <Typography variant="body1" color="text.secondary">
        {networkName}
      </Typography>
    </Box>
  );
}
